import "./Home.style.css";

const Home = () => {
  return (
    <div className="home-container" id="home">
      <h1>Nikola Ristoski</h1>
      <p>MERN Stack Developer</p>
    </div>
  );
};
export default Home;
